export default __webpack_public_path__ + "static/media/ReadyAPI-Logo.00c1b0c5.svg";